import { iconList } from '@design-system/index'
import type { DefaultProps, HtmlElementProps } from '@design-system/types/props'

import S from './IconTextButton.style'

type Props = {
  iconName: keyof typeof iconList
  text?: string
  size?: 'small' | 'medium'
  color?: keyof typeof S.colorTheme
} & DefaultProps &
  HtmlElementProps<HTMLButtonElement>

const IconTextButton = ({
  iconName,
  text,
  size = 'medium',
  color = 'middleGray',
  ...props
}: Props) => {
  const Icon = iconList[iconName]

  return (
    <button css={[S.default, S.size[size], S.colorTheme[color]]} {...props}>
      <Icon />
      {text}
    </button>
  )
}

export default IconTextButton
